/**
 * Whether the user menu should offer a logout action.
 *
 * Logout is meaningful only when the user owns the Auth0 session. Scout is
 * standalone-only today — there is no SMART-on-FHIR launch and no EHR-owned
 * session — so this is unconditionally `true`.
 *
 * Arc's counterpart returns `isAdmin` as a proxy for standalone mode, because Arc
 * can also run embedded in the EHR. Scout has no embedded path to distinguish, so
 * the honest answer here is a constant rather than a borrowed proxy. This hook is
 * the single seam to change if Scout ever gains an embedded mode; nothing else
 * reads it.
 */
export const useCanLogout = (): boolean => true
